<template>
  <upload @btn-update="handleStyle"/>
</template>
<script>
//有时组件内部是动态加载，dom是变化的，所以此处支持监听子组件更新事件上报
import upload from "../base/linkage-upload";
export default {
  components: { upload },
  mounted() {
    this.handleStyle();
  },
  methods: {
    handleStyle() {
      this.$nextTick(x => {
        //处理个性化样式
        let dom = document.querySelector(
          "div[class~='multi-upload-input-active']"
        );
        let dom2 = document.querySelector("div[class~='multi-upload-input']");

        if (dom) {
          dom.classList.add("au-multi-submit-active");
        }
        if (dom2) {
          dom2.classList.add("au-multi-submit");
        }
      });
    }
  }
};
</script>
